<div class="subscription">
    <calsoft-purchase [item]="item" [category]="category"   ></calsoft-purchase>
</div>

<div class="margin-t10" *ngIf="EnablePayment==1">
    <calsoft-subscription-plan fxFlex="100" [type]="'2'"></calsoft-subscription-plan>
</div>